var exports = {
  "MY": "OAuthAuthorizePage.module__page___em0xZ0",
  "g4": "OAuthAuthorizePage.module__loadingContainer___em0xZ0",
  "Un": "OAuthAuthorizePage.module__errorContainer___em0xZ0",
  "ow": "OAuthAuthorizePage.module__errorContent___em0xZ0",
  "JU": "OAuthAuthorizePage.module__errorTitle___em0xZ0",
  "kc": "OAuthAuthorizePage.module__errorText___em0xZ0",
  "d1": "OAuthAuthorizePage.module__heroCard___em0xZ0",
  "iC": "OAuthAuthorizePage.module__heroCopy___em0xZ0",
  "ZY": "OAuthAuthorizePage.module__heroTitle___em0xZ0",
  "fd": "OAuthAuthorizePage.module__heroDescription___em0xZ0",
  "$2": "OAuthAuthorizePage.module__cardGrid___em0xZ0",
  "Ql": "OAuthAuthorizePage.module__accountList___em0xZ0",
  "ts": "OAuthAuthorizePage.module__sectionDivider___em0xZ0",
  "nd": "OAuthAuthorizePage.module__panel___em0xZ0",
  "bV": "OAuthAuthorizePage.module__sectionHeader___em0xZ0",
  "Gf": "OAuthAuthorizePage.module__sectionTitle___em0xZ0",
  "yV": "OAuthAuthorizePage.module__sectionDescription___em0xZ0",
  "s0": "OAuthAuthorizePage.module__inlineStatus___em0xZ0",
  "Jb": "OAuthAuthorizePage.module__scopeList___em0xZ0",
  "_9": "OAuthAuthorizePage.module__permissionScrollContainer___em0xZ0",
  "C6": "OAuthAuthorizePage.module__permissionScroller___em0xZ0",
  "Mg": "OAuthAuthorizePage.module__permissionList___em0xZ0",
  "ce": "OAuthAuthorizePage.module__permissionRow___em0xZ0",
  "Ck": "OAuthAuthorizePage.module__permissionLabel___em0xZ0",
  "rJ": "OAuthAuthorizePage.module__scopeRow___em0xZ0",
  "BB": "OAuthAuthorizePage.module__scopeHeading___em0xZ0",
  "OK": "OAuthAuthorizePage.module__scopeName___em0xZ0",
  "RJ": "OAuthAuthorizePage.module__scopeDescription___em0xZ0",
  "Pp": "OAuthAuthorizePage.module__scopeChip___em0xZ0",
  "p$": "OAuthAuthorizePage.module__emptyState___em0xZ0",
  "uL": "OAuthAuthorizePage.module__caution___em0xZ0",
  "iB": "OAuthAuthorizePage.module__dangerNotice___em0xZ0",
  "mW": "OAuthAuthorizePage.module__successScreen___em0xZ0",
  "n7": "OAuthAuthorizePage.module__successIconCircle___em0xZ0",
  "FU": "OAuthAuthorizePage.module__successIcon___em0xZ0",
  "QK": "OAuthAuthorizePage.module__successTitle___em0xZ0",
  "s3": "OAuthAuthorizePage.module__successSubtitle___em0xZ0",
  "cs": "OAuthAuthorizePage.module__successAction___em0xZ0",
  "By": "OAuthAuthorizePage.module__guildOption___em0xZ0",
  "rZ": "OAuthAuthorizePage.module__guildValue___em0xZ0",
  "XN": "OAuthAuthorizePage.module__guildAvatar___em0xZ0",
  "oM": "OAuthAuthorizePage.module__guildAvatarPlaceholder___em0xZ0",
  "p2": "OAuthAuthorizePage.module__guildOptionLabel___em0xZ0",
  "RG": "OAuthAuthorizePage.module__guildOptionDisabled___em0xZ0",
  "p4": "OAuthAuthorizePage.module__guildOptionNotice___em0xZ0",
  "A2": "OAuthAuthorizePage.module__actionSection___em0xZ0",
  "PJ": "OAuthAuthorizePage.module__footerText___em0xZ0",
  "o1": "OAuthAuthorizePage.module__actions___em0xZ0",
  "hP": "OAuthAuthorizePage.module__actionButton___em0xZ0",
};

module.exports = exports;
